import { lazy } from "react";

const AuthPage = lazy(() => import("./ui/AuthPage"));

export { AuthPage };
